/** @format */

import * as React from 'react'
import { getDisplayName } from './getDisplayName'

const noop = () => ({})

export const connect = (store, mapState = noop) => Comp =>
  class extends React.Component {
    static displayName = `@connect(${getDisplayName(Comp)})`

    componentDidMount() {
      this.mount = true
      this.unsubscribe = store.subscribe(_ => this.mount && this.forceUpdate())
    }

    componentWillUnmount() {
      this.mount = false
      this.unsubscribe()
    }

    render() {
      const props = {
        ...this.props,
        ...mapState(store.getState(), this.props),
      }
      return <Comp {...props} />
    }
  }
